// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddProduct_addProduct__CV3-d {
  width: 100%;
  max-width: 100rem;
  margin: 2rem auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.AddProduct_addProduct__tracker__-jCDY {
  background: var(--color-white);
  border: 1px solid var(--color-grey-2);
  border-radius: 1.2rem;
  padding: 1.6rem;
}
.AddProduct_addProduct__topRail__AYYkg {
  position: sticky;
  top: 1.2rem;
  z-index: 30;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: var(--color-white);
  padding: 2rem 0;
}
.AddProduct_addProduct__trackerHeader__jfsYF {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.AddProduct_addProduct__progressBar__s79i9 {
  width: 100%;
  height: 1rem;
  background: var(--color-table-grey);
  border-radius: 999px;
  overflow: hidden;
}
.AddProduct_addProduct__progressFill__HCy4N {
  height: 100%;
  background: var(--color-fash-primary);
  transition: width 0.25s ease;
}
.AddProduct_addProduct__accordion__\\+nBW\\+ {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}
.AddProduct_addProduct__item__h7VL8 {
  border: 1px solid var(--color-grey-2);
  border-radius: 1.2rem;
  overflow: hidden;
  background: var(--color-white);
}
.AddProduct_addProduct__trigger__CMFbi {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.4rem 1.6rem;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 1.6rem;
  font-weight: 600;
}
.AddProduct_addProduct__status__6c9Uv {
  padding: 0.4rem 0.9rem;
  border-radius: 999px;
  font-size: 1.2rem;
  font-weight: 700;
}
.AddProduct_addProduct__statusDone__m7N2D {
  background: rgba(23, 173, 23, 0.14);
  color: var(--color-green);
}
.AddProduct_addProduct__statusPending__jzEpE {
  background: rgba(255, 166, 0, 0.15);
  color: #8f5b00;
}
.AddProduct_addProduct__panel__-41YV {
  border-top: 1px solid var(--color-grey-2);
  padding: 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.AddProduct_addProduct__errorCard__zOINg {
  background: #fff5f5;
  border: 1px solid #f1b1b1;
  border-radius: 1.2rem;
  padding: 1.2rem 1.4rem;
  box-shadow: 0 0.4rem 1.4rem rgba(0, 0, 0, 0.08);
}
.AddProduct_addProduct__errorCardTitle__4zSF\\+ {
  font-size: 1.35rem;
  font-weight: 700;
  color: #9b1c1c;
  margin-bottom: 0.8rem;
}
.AddProduct_addProduct__errorChips__1nb2E {
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
}
.AddProduct_addProduct__errorChip__DrpR- {
  border: 1px solid #e28c8c;
  background: #fff;
  color: #7d1818;
  border-radius: 999px;
  padding: 0.5rem 0.9rem;
  font-size: 1.2rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.AddProduct_addProduct__errorChip__DrpR-:hover {
  background: #ffe8e8;
}
.AddProduct_addProduct__placeholder__GjXL6 {
  padding: 1.4rem;
  border: 1px dashed var(--color-grey-2);
  border-radius: 1rem;
  color: var(--color-grey);
  font-size: 1.4rem;
}
.AddProduct_addProduct__actions__lyrAJ {
  display: flex;
  gap: 0.8rem;
  justify-content: flex-end;
}

@media (max-width: 768px) {
  .AddProduct_addProduct__topRail__AYYkg {
    top: 0.8rem;
  }
  .AddProduct_addProduct__errorCard__zOINg {
    padding: 1rem 1.1rem;
  }
}
.AddProduct_checks__QShBv {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
}
.AddProduct_checks_group__08uIW {
  align-self: center;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Admin/AddProduct.module.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACD;AACC;EACC,8BAAA;EACA,qCAAA;EACA,qBAAA;EACA,eAAA;AACF;AAEC;EACC,gBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oCAAA;EACA,eAAA;AAAF;AAGC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AADF;AAIC;EACC,WAAA;EACA,YAAA;EACA,mCAAA;EACA,oBAAA;EACA,gBAAA;AAFF;AAKC;EACC,YAAA;EACA,qCAAA;EACA,4BAAA;AAHF;AAMC;EACC,aAAA;EACA,sBAAA;EACA,WAAA;AAJF;AAOC;EACC,qCAAA;EACA,qBAAA;EACA,gBAAA;EACA,8BAAA;AALF;AAQC;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AANF;AASC;EACC,sBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;AAPF;AAUC;EACC,mCAAA;EACA,yBAAA;AARF;AAWC;EACC,mCAAA;EACA,cAAA;AATF;AAYC;EACC,yCAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAVF;AAaC;EACC,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;EACA,+CAAA;AAXF;AAcC;EACC,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAZF;AAeC;EACC,aAAA;EACA,eAAA;EACA,WAAA;AAbF;AAgBC;EACC,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAdF;AAgBE;EACC,mBAAA;AAdH;AAkBC;EACC,eAAA;EACA,sCAAA;EACA,mBAAA;EACA,wBAAA;EACA,iBAAA;AAhBF;AAmBC;EACC,aAAA;EACA,WAAA;EACA,yBAAA;AAjBF;;AAqBA;EAEE;IACC,WAAA;EAnBD;EAsBA;IACC,oBAAA;EApBD;AACF;AAwBA;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;AAtBD;AAwBC;EACC,kBAAA;AAtBF","sourcesContent":[".addProduct {\n\twidth: 100%;\n\tmax-width: 100rem;\n\tmargin: 2rem auto;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 2rem;\n\n\t&__tracker {\n\t\tbackground: var(--color-white);\n\t\tborder: 1px solid var(--color-grey-2);\n\t\tborder-radius: 1.2rem;\n\t\tpadding: 1.6rem;\n\t}\n\n\t&__topRail {\n\t\tposition: sticky;\n\t\ttop: 1.2rem;\n\t\tz-index: 30;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 1rem;\n\t\tbackground-color: var(--color-white);\n\t\tpadding: 2rem 0;\n\t}\n\n\t&__trackerHeader {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tmargin-bottom: 1rem;\n\t}\n\n\t&__progressBar {\n\t\twidth: 100%;\n\t\theight: 1rem;\n\t\tbackground: var(--color-table-grey);\n\t\tborder-radius: 999px;\n\t\toverflow: hidden;\n\t}\n\n\t&__progressFill {\n\t\theight: 100%;\n\t\tbackground: var(--color-fash-primary);\n\t\ttransition: width 0.25s ease;\n\t}\n\n\t&__accordion {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 1.2rem;\n\t}\n\n\t&__item {\n\t\tborder: 1px solid var(--color-grey-2);\n\t\tborder-radius: 1.2rem;\n\t\toverflow: hidden;\n\t\tbackground: var(--color-white);\n\t}\n\n\t&__trigger {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tpadding: 1.4rem 1.6rem;\n\t\tborder: none;\n\t\tbackground: transparent;\n\t\tcursor: pointer;\n\t\tfont-size: 1.6rem;\n\t\tfont-weight: 600;\n\t}\n\n\t&__status {\n\t\tpadding: 0.4rem 0.9rem;\n\t\tborder-radius: 999px;\n\t\tfont-size: 1.2rem;\n\t\tfont-weight: 700;\n\t}\n\n\t&__statusDone {\n\t\tbackground: rgba(23, 173, 23, 0.14);\n\t\tcolor: var(--color-green);\n\t}\n\n\t&__statusPending {\n\t\tbackground: rgba(255, 166, 0, 0.15);\n\t\tcolor: #8f5b00;\n\t}\n\n\t&__panel {\n\t\tborder-top: 1px solid var(--color-grey-2);\n\t\tpadding: 1.6rem;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 2rem;\n\t}\n\n\t&__errorCard {\n\t\tbackground: #fff5f5;\n\t\tborder: 1px solid #f1b1b1;\n\t\tborder-radius: 1.2rem;\n\t\tpadding: 1.2rem 1.4rem;\n\t\tbox-shadow: 0 0.4rem 1.4rem rgba(0, 0, 0, 0.08);\n\t}\n\n\t&__errorCardTitle {\n\t\tfont-size: 1.35rem;\n\t\tfont-weight: 700;\n\t\tcolor: #9b1c1c;\n\t\tmargin-bottom: 0.8rem;\n\t}\n\n\t&__errorChips {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tgap: 0.8rem;\n\t}\n\n\t&__errorChip {\n\t\tborder: 1px solid #e28c8c;\n\t\tbackground: #fff;\n\t\tcolor: #7d1818;\n\t\tborder-radius: 999px;\n\t\tpadding: 0.5rem 0.9rem;\n\t\tfont-size: 1.2rem;\n\t\tfont-weight: 600;\n\t\tcursor: pointer;\n\t\ttransition: all 0.2s ease;\n\n\t\t&:hover {\n\t\t\tbackground: #ffe8e8;\n\t\t}\n\t}\n\n\t&__placeholder {\n\t\tpadding: 1.4rem;\n\t\tborder: 1px dashed var(--color-grey-2);\n\t\tborder-radius: 1rem;\n\t\tcolor: var(--color-grey);\n\t\tfont-size: 1.4rem;\n\t}\n\n\t&__actions {\n\t\tdisplay: flex;\n\t\tgap: 0.8rem;\n\t\tjustify-content: flex-end;\n\t}\n}\n\n@media (max-width: 768px) {\n\t.addProduct {\n\t\t&__topRail {\n\t\t\ttop: 0.8rem;\n\t\t}\n\n\t\t&__errorCard {\n\t\t\tpadding: 1rem 1.1rem;\n\t\t}\n\t}\n}\n\n.checks {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin: 1rem 0 2rem 0;\n\n\t&_group {\n\t\talign-self: center;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addProduct": `AddProduct_addProduct__CV3-d`,
	"addProduct__tracker": `AddProduct_addProduct__tracker__-jCDY`,
	"addProduct__topRail": `AddProduct_addProduct__topRail__AYYkg`,
	"addProduct__trackerHeader": `AddProduct_addProduct__trackerHeader__jfsYF`,
	"addProduct__progressBar": `AddProduct_addProduct__progressBar__s79i9`,
	"addProduct__progressFill": `AddProduct_addProduct__progressFill__HCy4N`,
	"addProduct__accordion": `AddProduct_addProduct__accordion__+nBW+`,
	"addProduct__item": `AddProduct_addProduct__item__h7VL8`,
	"addProduct__trigger": `AddProduct_addProduct__trigger__CMFbi`,
	"addProduct__status": `AddProduct_addProduct__status__6c9Uv`,
	"addProduct__statusDone": `AddProduct_addProduct__statusDone__m7N2D`,
	"addProduct__statusPending": `AddProduct_addProduct__statusPending__jzEpE`,
	"addProduct__panel": `AddProduct_addProduct__panel__-41YV`,
	"addProduct__errorCard": `AddProduct_addProduct__errorCard__zOINg`,
	"addProduct__errorCardTitle": `AddProduct_addProduct__errorCardTitle__4zSF+`,
	"addProduct__errorChips": `AddProduct_addProduct__errorChips__1nb2E`,
	"addProduct__errorChip": `AddProduct_addProduct__errorChip__DrpR-`,
	"addProduct__placeholder": `AddProduct_addProduct__placeholder__GjXL6`,
	"addProduct__actions": `AddProduct_addProduct__actions__lyrAJ`,
	"checks": `AddProduct_checks__QShBv`,
	"checks_group": `AddProduct_checks_group__08uIW`
};
export default ___CSS_LOADER_EXPORT___;
